const AUTH_TOKEN_KEY = "authToken";
const IMPERSONATION_KEY = "impersonationSession";

const scopedKeys = new Set([AUTH_TOKEN_KEY, "apiKey", "userName"]);

function safeParse(value) {
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
}

function getToken() {
  return sessionStorage.getItem(AUTH_TOKEN_KEY) || localStorage.getItem(AUTH_TOKEN_KEY);
}

function getItem(key) {
  return sessionStorage.getItem(key) ?? localStorage.getItem(key);
}

function isImpersonating() {
  return Boolean(sessionStorage.getItem(IMPERSONATION_KEY));
}

function getImpersonationMeta() {
  return safeParse(sessionStorage.getItem(IMPERSONATION_KEY));
}

function setItem(key, value) {
  sessionStorage.setItem(key, value);
  if (!isImpersonating() || !scopedKeys.has(key)) {
    localStorage.setItem(key, value);
  }
}

function removeItem(key) {
  sessionStorage.removeItem(key);
  localStorage.removeItem(key);
}

function clearScopedSessionStorage() {
  scopedKeys.forEach((key) => sessionStorage.removeItem(key));
  sessionStorage.removeItem(IMPERSONATION_KEY);
}

function setPrimaryAuthToken(token) {
  clearScopedSessionStorage();
  sessionStorage.setItem(AUTH_TOKEN_KEY, token);
  localStorage.setItem(AUTH_TOKEN_KEY, token);
}

function startImpersonationSession(payload) {
  clearScopedSessionStorage();
  sessionStorage.setItem(AUTH_TOKEN_KEY, payload.token);
  sessionStorage.setItem(
    IMPERSONATION_KEY,
    JSON.stringify({
      expiresAt: payload.expiresAt,
      impersonatedUser: payload.impersonatedUser,
      impersonator: payload.impersonator,
    }),
  );
}

function writeImpersonationSession(storage, payload) {
  storage.setItem(AUTH_TOKEN_KEY, payload.token);
  storage.setItem(
    IMPERSONATION_KEY,
    JSON.stringify({
      expiresAt: payload.expiresAt,
      impersonatedUser: payload.impersonatedUser,
      impersonator: payload.impersonator,
    }),
  );
}

function openImpersonationWindow(payload, redirectPath) {
  const childWindow = window.open("", "_blank");

  if (!childWindow) {
    return false;
  }

  childWindow.sessionStorage.clear();
  writeImpersonationSession(childWindow.sessionStorage, payload);
  childWindow.location.replace(`${window.location.origin}${redirectPath}`);
  return true;
}

function endImpersonationSession() {
  clearScopedSessionStorage();
}

function clearAllSessions() {
  clearScopedSessionStorage();
  scopedKeys.forEach((key) => localStorage.removeItem(key));
}

const appSession = {
  getToken,
  getItem,
  setItem,
  removeItem,
  setPrimaryAuthToken,
  startImpersonationSession,
  openImpersonationWindow,
  endImpersonationSession,
  clearAllSessions,
  isImpersonating,
  getImpersonationMeta,
};

if (typeof window !== "undefined") {
  window.__appSession = appSession;
}

export default appSession;
